import { render, staticRenderFns } from "./addressEdit.vue?vue&type=template&id=78825fac&"
import script from "./addressEdit.vue?vue&type=script&lang=js&"
export * from "./addressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports